import _ from "lodash";
import dayjs from 'dayjs';
import { useReactToPrint } from 'react-to-print';
import { add } from 'mathjs';
import React, { useRef } from "react";
import { Bar, Line } from 'react-chartjs-2';
import { LineGraph } from '../users/benchmarks_graph_component.js';
        // import QRCode from 'qrcode'

        // // With promises
        // QRCode.toDataURL('I am a pony!')
        // .then(url => {
        //     console.log(url)
        // })
        // .catch(err => {
        //     console.error(err)
        // })

        // // With async/await
        // const generateQR = async text => {
        // try {
        //     console.log(await QRCode.toDataURL(text))
        // } catch (err) {
        //     console.error(err)
        // }
        // }


// import ReactToPrint from "react-to-print";

// export function PrintingComponent({ children }) {
//     console.log({children})
//     // const auth = useAuthUser();
//     const linkToPrint = () => {
//         return (
//             <button>Click To PrintOF Body</button>
//         )
//     }
//     const componentRef = useRef();
//     return (
//         <>
//             <ReactToPrint trigger={linkToPrint} content={() => componentRef.current} />
//             <div ref={componentRef}>
//                 {children}
//             </div>
//         </>
//     );
// }


export class Printer extends React.PureComponent {
  componentRef = React.createRef();

  // const ctx = document.getElementById('myChart');

  // new Chart(ctx, {
  //   type: 'bar',
  //   data: {
  //     labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
  //     datasets: [{
  //       label: '# of Votes',
  //       data: [12, 19, 3, 5, 2, 3],
  //       borderWidth: 1
  //     }]
  //   },
  //   options: {
  //     scales: {
  //       y: {
  //         beginAtZero: true
  //       }
  //     }
  //   }
  // });

  
  // render() {

  //   return (
  //     <div>
  //     <canvas id="myChart"></canvas>
  //   </div>
  //       )
  // }


//   // JS Solution:
//   const img = new Image();
//    img.onload = () => {
//        const canvas = document.getElementById('myCanvas');
//        const ctx = canvas.getContext('2d');
//        ctx.drawImage(img, 0, 0);
//    };
//    img.src = 'your-image.jpg';  // Or the URL of your image

// // Canvas issue:
//   // Example assuming 'sourceCanvas' is the canvas with the problem
//   const sourceCanvas = document.createElement('canvas');
//   sourceCanvas.width = 200;  // Set width
//   sourceCanvas.height = 100; // Set height

//   const sourceCtx = sourceCanvas.getContext('2d');
//   // ... draw on sourceCanvas using sourceCtx ...

//   const destinationCanvas = document.getElementById('myCanvas');
//   const destCtx = destinationCanvas.getContext('2d');
//   destCtx.drawImage(sourceCanvas, 0, 0); // Now it should work



//   // Other solution
//   !function(e, t) {
//     // ... other code ...
  
//     const sourceCanvas = document.createElement('canvas');
//     sourceCanvas.width = 300;
//     sourceCanvas.height = 200;
//     const sourceCtx = sourceCanvas.getContext('2d');
//     // ... Draw something on sourceCanvas using sourceCtx ...
  
//     const destCanvas = document.getElementById('myCanvas');
//     const destCtx = destCanvas.getContext('2d');
  
//     // Only draw after ensuring sourceCanvas has dimensions
//     destCtx.drawImage(sourceCanvas, 0, 0);
  
//     // ... rest of your code ...


  render() {

    console.log("props: ", this.props)
    console.log("width: ", window.innerHeight)
    if ( this.props.graph_type === 'line' ) {
        return (
            <div id="divcontents" className="mt-5 ms-5 w-100" style={{ marginTop: 50+'px', marginLeft: 50+'px', marginRight: 50+'px', display: 'flex', justifyContent: 'center'}}>
                <style type="text/css" media="print">
                    {" @page { size: landscape; } "}
                </style>                
                <Line options={this.props.options} data={this.props.data} />
            </div>
        );
    } 
    else if ( this.props.graph_type === 'bar' ) {
      return (
          <div id="divcontents" className="mt-5 ms-5 w-100" style={{ marginTop: 50+'px', marginLeft: 50+'px', marginRight: 50+'px', display: 'flex', justifyContent: 'center'}}>
              <style type="text/css" media="print">
                  {" @page { size: landscape; } "}
              </style>                
              <Bar options={this.props.options} data={this.props.data} />
          </div>
      );
  }

  }
}

// export function PrintingComponent() {
// const componentRef = useRef();
//   const handlePrint = useReactToPrint({
//     content: () => componentRef.current,
//   });

//   return (
//     <div>
//       <div
//       style={{ display: "none" }}// This make ProductionTag show   only while printing
//       > 
//        <ProductionTag ref={componentRef} />
//       </div>
//       <button onClick={handlePrint}>Print this out!</button>
//     </div>
//   );
// };
//  default PrintingComponent;

